export default {"src":"/_next/static/media/app-appstore.bf8e980e.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};